// OPS7 (docs/build-briefs/OPS7-database-unreachable-is-503.md): the one sentence every screen shows when the server
// answers 503 `service_unavailable`, meaning its database cannot be reached (stopped, still starting). Pure: no DOM,
// no fetch. The server sends the same text (src/domain/errors.ts, SERVICE_UNAVAILABLE_MESSAGE); the screens use this
// constant for the code so a stale or reworded server message can never reach a person.

export const SERVICE_UNAVAILABLE_CODE = "service_unavailable";
export const SERVICE_UNAVAILABLE_SENTENCE = "Can't reach the server. Try again in a minute.";

export function isServiceUnavailable(status: number, body: unknown): boolean {
  return (
    status === 503 &&
    typeof body === "object" &&
    body !== null &&
    (body as { error?: unknown }).error === SERVICE_UNAVAILABLE_CODE
  );
}

/** Returns the body with the sentence as its message when it is the service_unavailable answer, otherwise the body
 * untouched (same object). */
export function withServiceUnavailableSentence<T>(status: number, body: T): T {
  if (!isServiceUnavailable(status, body)) return body;
  return { ...(body as object), message: SERVICE_UNAVAILABLE_SENTENCE } as T;
}

/** Reads a response body as JSON (undefined when it is not JSON), with the sentence applied for service_unavailable. */
export async function readJsonBody(response: Response): Promise<unknown> {
  const parsed: unknown = await response.json().catch(() => undefined);
  return withServiceUnavailableSentence(response.status, parsed);
}
